import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_Dictionary = {
    vv1: {
        getDictionaryFiles: { method: HttpMethod.POST, path: 'dictionary/get-files' },
    }
};
//# sourceMappingURL=apis.js.map